import {Component} from 'react';
import injectSheet from 'react-jss';
import qs from 'query-string';

import greetingStyles from '-/styles/sections/greeting';
import {get} from '-/util/lodash';
import {retrieveDocumentLink} from '-/api/api';
import {getOfferId} from '-/util/util';
import SessionService from '-/services/SessionService';

class DocumentsLanding extends Component {
    componentDidMount() {
        const queryParams = qs.parse(location.search);
        const {documentId} = queryParams;
        const isAuthenticated = SessionService.authenticated();

        if (documentId && isAuthenticated) {
            const documents = get(this.props, 'documents.documents');

            if (Array.isArray(documents) && documents.length) {
                const document = documents.find(doc => doc._id === documentId);

                if (document) {
                    const {title} = document;

                    this.onDownloadClick(documentId, title);
                }
            }
        }
    }

    openContentLink = (base64, opts = {}) => {
        const {filename} = opts;
        
        let contentLink = document.createElement('a');
    
        contentLink.target = '_blank';
        contentLink.download = filename;
        contentLink.href = `data:application/pdf;base64,${base64}`;
        contentLink.click();
    };

    onDownloadClick = async(documentId, title) => {
        const offerId = getOfferId();
        const {data} = await retrieveDocumentLink(offerId, documentId);

        if (data) {
            this.openContentLink(data, {filename: title});
        }
    };

    render() {
        const {classes = {}} = this.props;
        const documents = get(this.props, 'documents.documents') || [];
        const h1Style = {
            fontSize: '2.75rem',
            fontWeight: 'bold'
        };
        const h3Style = {
            fontSize: '1.75em',
            fontWeight: 'normal',
            marginBottom: 5
        };

        return (
            <section className={classes.root}>
                <h1 style={h1Style}>Your Documents</h1>
                {documents.length === 0 ?
                    <p>You don't have any documents yet</p>
                    :
                    <div className={classes.documents}>
                        {documents.map(document => {
                            const {_id, description, title} = document;

                            return (
                                <div key={_id} className={classes.document}>
                                    <h3 style={h3Style}>
                                        {title}
                                        <span style={{marginLeft: 10, color: 'green', cursor: 'pointer'}} title={`Download ${title}`} onClick={this.onDownloadClick.bind(this, _id, title)}>
                                            <i className="fa fa-download" />
                                        </span>
                                    </h3>
                                    {description && <p>{document.description}</p>}
                                </div>
                            );
                        })}
                    </div>
                }
            </section>
        );
    }
}

export default injectSheet(greetingStyles)(DocumentsLanding);
